
export class SearchRxTag {
    Name: string = null;
    Desc: number = null;
    Pagenumber: number = null;
    Pagesize: number = null;
}
